export const numFromStr = (str: string): Array<number> => {
    return [...str]
        .map((i) => (!isNaN(+i) || i === '.' ? i : ' '))
        .join('')
        .split(' ')
        .filter((i) => i !== '')
        .map((i) => +i);
};
